import { Component, forwardRef, Input, OnInit, Provider } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { GeneralHelper } from 'src/app/helpers/general-helper';

export const TEXTAREA_WITH_LABEL_CONTROL_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LabelWithTextAreaComponent),
  multi: true
};

@Component({
  selector: 'textarea-with-label',
  templateUrl: './textarea-with-label.component.html',
  styleUrls: ['./textarea-with-label.component.scss'],
  providers: [TEXTAREA_WITH_LABEL_CONTROL_VALUE_ACCESSOR]
})
export class LabelWithTextAreaComponent
  implements ControlValueAccessor, OnInit {
  @Input()
  label: string;

  @Input()
  placeholder: string = '';

  @Input()
  disabled: boolean = false;

  @Input()
  formControl?: FormControl;

  @Input()
  minWidth: number;

  minWidthStyle: { [klass: string]: any };

  innerValue: any = undefined;
  onTouchedCallback: () => void = GeneralHelper.noop;
  onChangeCallback: (_: any) => void = GeneralHelper.noop;

  ngOnInit(): void {
    if (this.minWidth != null) {
      this.minWidthStyle = { 'min-width': `${this.minWidth}px` };
    }
  }

  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  onBlur() {
    this.onTouchedCallback();
  }

  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: (_: any) => void) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouchedCallback = fn;
  }
}
